import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { publishBatteryArbitrage } from "./battery-arbitrage-cache"
import type {
  BatteryArbitrageDto,
  BatterySavingsVisibility,
} from "../dto/battery-arbitrage.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

export default function useSetBatterySavingsVisibility(): UseMutationResult<
  BatteryArbitrageDto,
  unknown,
  { proposalId: string; visibility: BatterySavingsVisibility }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, visibility }) =>
      batteryProposalService.setArbitrageVisibility(proposalId, visibility),
    onSuccess: (arbitrage, { proposalId }) =>
      publishBatteryArbitrage(queryClient, proposalId, arbitrage),
  })
}
